import React, { useEffect, useState, useContext } from 'react'
// import { Dialog, Input, Form, Stepper, Switch, Toast } from 'antd-mobile';
import {
  Spin,
  Segmented,
  ConfigProvider,
  Select,
  message,
  Form,
  Tooltip,
  Button,
  Image,
} from 'antd'
import KitDetailContent from '../KitDetailContent'
import styles from './index.module.less'
import { cloneDeep, isArray, isBoolean } from 'lodash-es'
import { SDrawerOrModal } from 'shj-components'
import { listProductSkuRelationSpuFormat, selectMaterialDynaOptions } from '@/services/order'
import { useParams } from 'react-router-dom'

const KitDetailDialogV3 = ({
  open = false,
  closeDialog = () => ({}),
  confirmText = '确定',
  productInfo = {},
  combinationInfoList = [],
  kitSku = {},
  confirmInfo = () => ({}),
  setKitSku = () => ({}),
  onOk = async () => ({}),
  activityInfo = {},
  title = '加入购物车',
  selectType = '',
  packDtlList = [],
  generalId = '',
  checkType = '',
  recordItem = {},
  okText = '',
  readOnly = false,
}: any) => {
  const [form] = Form.useForm()
  const [spinLoading, setSpinLoading] = useState(false)
  const [mustChooseList, setMustChooseList] = useState<Array<any>>([])
  const [noMustChooseList, setNoMustChooseList] = useState<Array<any>>([])
  const [combinationPriceType, setCombinationPriceType] = useState('')
  const [combinationPrice, setCombinationPrice] = useState('')
  const [combinationSkuToPriceMap, setCombinationSkuToPriceMap] = useState({})
  const [btnLoading, setBtnLoading] = useState(false)
  const { budgetId, type } = useParams() // 报价id
  const typeString = type || selectType
  useEffect(() => {
    setSpinLoading(true)
  }, [open])
  useEffect(() => {
    productInfo?.combinationInfo && getCombination()
  }, [productInfo])
  const tagsMap = {
    NATIONAL_UPPLEMENT: 'nationalCss',
  }

  useEffect(() => {
    if (combinationPriceType === 'CALCULATE') {
      let list: any = [...mustChooseList, ...noMustChooseList]
      // 处理一下如果只有一个sku的情况
      let noSelectIdFlag = false // 是否有未选择sku的
      list.forEach((el: any) => {
        if (el.selectedSkuList.length === 1) {
          el.selectSkuId = el.selectedSkuList[0].id
        }
        // 如果有未选择sku且有规格的，则不请求显示价格
        if ((!el.selectSkuId && el.required) || (!el.required && el.checked && !el.selectSkuId)) {
          noSelectIdFlag = true
        }
      })
      if (noSelectIdFlag) {
        console.log('有未选择sku的，则不请求显示价格')
        return
      } else {
        // 当全部sku都有选择的时候，再去请求价格
        setSpinLoading(true)
        listProductSkuRelationSpuFormat({
          data: {
            quoteBudgetId: budgetId,
            productSpuId: productInfo.id,
            productSkuId: kitSku.id,
            packDtlList: list.filter(el => el.selectSkuId && el.checked),
            activityId: activityInfo?.activityId || null,
            activityProductId: activityInfo?.activityProductId || null,
            generalId:
              typeString === 'UP_DOWN' || typeString === 'GENERAL' ? generalId || null : null,
            priceCalcType: typeString === 'UP_DOWN' ? 'CHANGE_LEVEL' : null,
            budgetDtlId: recordItem?.id || null,
          },
        })
          .then((res: any) => {
            console.log(res, 'res')
            setCombinationPrice(res?.skuList[0]?.priceInfo?.customerPrice || 0)
          })
          .finally(() => {
            setSpinLoading(false)
          })
      }
    }
  }, [mustChooseList, noMustChooseList])

  const formatCombinationData = (must: any, noMust: any, format = false) => {
    // 组合数据处理
    const newMustChooseList = must.map(item => {
      // 只有一个sku就默认选中，且不能修改规格，相对应就没有回显的逻辑
      if (item.selectedSkuList?.length === 1) {
        return {
          ...item,
          selectSkuId: item.selectSkuId,
          selectPrice: item.selectPrice || '',
          checked: true,
          useArgList: [],
          onlyOne: true,
        }
      }

      let skuId = ''
      let price = ''
      const skuMap: any = {}
      // 处理规格
      const selectArgList = item?.useArgList?.map(arg => {
        const choose = arg?.list?.filter(choice => choice.isActive) || []
        skuMap[arg.argCode] = choose?.[0]?.valueId
        return {
          argId: arg.argId,
          argCode: arg.argCode,
          argType: arg.argType,
          argValCode: choose?.[0]?.valueCode,
          argVal: choose?.[0]?.valueId,
        }
      })
      // 找sku
      item?.selectedSkuList?.forEach(sku => {
        const codeList = Object.keys(sku.argMap)
        const selectedCodeList = Object.keys(skuMap)
        if (codeList?.length === selectedCodeList?.length) {
          const filterList = codeList.filter(code => {
            return skuMap[code] === sku.argMap?.[code]?.valueId
          })
          if (filterList?.length === codeList?.length) {
            skuId = sku.id
            if (skuId) {
              price = combinationSkuToPriceMap?.[skuId] * (item.size || 0) || ''
            }
          }
        }
      })
      console.log(skuId, price, item, 'item', 'skuId, price')
      return {
        ...item,
        selectSkuId: skuId,
        selectArgList,
        selectPrice: price ? Number(price).toFixed(4) : '',
        checked: true,
      }
    })
    // 非必选
    const newNoMustChooseList = noMust.map(item => {
      if (!item.checked) {
        return {
          ...item,
          selectSkuId: '',
          selectPrice: '',
          // selectArgList: [],
        }
      }
      // 只有一个sku就默认选中，且不能修改规格，相对应就没有回显的逻辑
      if (item.selectedSkuList?.length === 1) {
        return {
          ...item,
          selectSkuId: item.selectSkuId,
          selectPrice: item.selectPrice || '',
          checked: true,
          useArgList: [],
          onlyOne: true,
        }
      }

      let skuId = ''
      let price = 0
      const skuMap: any = {}
      // 处理规格
      const selectArgList = item?.useArgList?.map(arg => {
        const choose = arg?.list?.filter(choice => choice.isActive) || []
        skuMap[arg.argCode] = choose?.[0]?.valueId
        return {
          argId: arg.argId,
          argCode: arg.argCode,
          argType: arg.argType,
          argValCode: choose?.[0]?.valueCode,
          argVal: choose?.[0]?.valueId,
        }
      })
      // 找sku
      item?.selectedSkuList?.forEach(sku => {
        const codeList = Object.keys(sku.argMap)
        const selectedCodeList = Object.keys(skuMap)
        if (codeList?.length === selectedCodeList?.length) {
          const filterList = codeList.filter(code => {
            return skuMap[code] === sku.argMap?.[code]?.valueId
          })
          if (filterList?.length === codeList?.length) {
            skuId = sku.id
            if (skuId) {
              price = combinationSkuToPriceMap?.[skuId] * (item.size || 0) || ''
            }
          }
        }
      })
      return {
        ...item,
        selectSkuId: skuId,
        selectPrice: price ? Number(price).toFixed(4) : '',
        selectArgList,
        checked: true,
      }
    })
    getSkuDynamicVoList(newMustChooseList, newNoMustChooseList)
    return [...newMustChooseList, ...newNoMustChooseList]
  }

  const confirmDialog = async () => {
    // 组合数据处理
    setBtnLoading(true)
    const combinationInfo = formatCombinationData(mustChooseList, noMustChooseList)
    const hasSkuList = combinationInfo.filter(item => item.selectSkuId)
    const hasCheckedList = combinationInfo.filter(item => item.checked)
    // const
    let noSkuProdInfo: any = {}
    if (hasSkuList?.length !== hasCheckedList?.length) {
      noSkuProdInfo = hasCheckedList?.filter(item => !item.selectSkuId)?.[0]
      message.error(
        `产品SPU：${noSkuProdInfo?.prodName}-${noSkuProdInfo?.id}未对应上SKU，请检查，可能原因：①没有适用该门店的SKU；②未选择商品规格`
      )
      return
    }
    console.log(combinationInfo, combinationPrice)

    await confirmInfo(combinationInfo, combinationPrice)
    setBtnLoading(false)
    closeDialog()
  }

  const handleSetPrice = (product: any) => {
    setCombinationPriceType(kitSku?.priceInfo?.customerPriceType)
    if (kitSku?.priceInfo?.customerPriceType !== 'CALCULATE') {
      setCombinationPrice(kitSku?.priceInfo?.customerPrice)
    } else {
      let map: any = {}
      product?.combinationInfo?.forEach((combination: any) => {
        combination?.selectedSkuList?.forEach((sku: any) => {
          map = {
            ...map,
            [sku.id]: sku.priceInfo?.customerPrice,
          }
        })
      })
      setCombinationSkuToPriceMap(map)
    }
  }

  const getCombination = async () => {
    try {
      // 处理组合数据，这地方就比较复杂了，要把必选项和非必选抽出来，同时处理他们各自的规格数据，因为规格数据只能从所有选择的sku里面提取，没有现成数据
      // 且提取完使用的规格，后续规格选择之间还要做选项联动
      if (productInfo && productInfo.combinationInfo?.length) {
        /**
         * 价格计算逻辑
         */
        handleSetPrice(productInfo)
        const formatSpecList = productInfo.combinationInfo?.map((com: any) => {
          // 只有一个sku就默认选中，且不能修改规格，相对应就没有回显的逻辑
          // 如果选材详情存在没有的时候 默认check需要根据packDtlList来判断
          if (com.selectedSkuList?.length === 1) {
            if (!packDtlList?.length && !combinationInfoList?.length) {
              return {
                ...com,
                selectSkuId: com.selectedSkuList?.[0]?.id,
                selectPrice: com.selectedSkuList?.[0]?.priceInfo?.customerPrice
                  ? Number(com.selectedSkuList?.[0]?.priceInfo?.customerPrice * com.size).toFixed(4)
                  : '',
                checked: isBoolean(com.checked) ? com.checked : true, // 默认选中
                useArgList: [],
                onlyOne: true,
              }
            } else {
              if (combinationInfoList && combinationInfoList.length) {
                // 只有一个sku id 但是选择了报价属性 不能直接默认初始渲染
                let materialNode = combinationInfoList.find(
                  (item: any) => item.id === com.id && item.materialDynaOptions
                )
                if (!materialNode) {
                  return {
                    ...com,
                    selectSkuId: com.selectedSkuList?.[0]?.id,
                    selectPrice: com.selectedSkuList?.[0]?.priceInfo?.customerPrice
                      ? Number(
                          com.selectedSkuList?.[0]?.priceInfo?.customerPrice * com.size
                        ).toFixed(4)
                      : '',
                    checked: isBoolean(com.checked)
                      ? com.checked
                      : combinationInfoList?.find((item: any) => item.id === com.id).checked,
                    useArgList: [],
                    onlyOne: true,
                  }
                }
              }
              if (packDtlList && packDtlList.length) {
                // 只有一个sku id 但是有packList里数据
                let materialNode = packDtlList.find(
                  (item: any) =>
                    item.sourceItemId === com?.selectedSkuList[0]?.id && item.materialDynaOptions
                )
                if (!materialNode) {
                  return {
                    ...com,
                    selectSkuId: com.selectedSkuList?.[0]?.id,
                    selectPrice: com.selectedSkuList?.[0]?.priceInfo?.customerPrice
                      ? Number(
                          com.selectedSkuList?.[0]?.priceInfo?.customerPrice * com.size
                        ).toFixed(4)
                      : '',
                    checked: packDtlList?.find(
                      (item: any) => item.sourceItemId === com.selectedSkuList[0]?.id
                    ),
                    useArgList: [],
                    onlyOne: true,
                  }
                }
              }
            }
          }

          const useArgMap: any = {} // 所有用过的规格和值
          com.selectedSkuList.forEach((sku: any) => {
            const keys = Object.keys(sku?.argMap)
            keys.forEach(key => {
              if (useArgMap[key]?.length) {
                if (!useArgMap[key].includes(sku?.argMap[key]?.valueId)) {
                  useArgMap[key].push(sku?.argMap[key]?.valueId)
                }
              } else {
                useArgMap[key] = [sku?.argMap[key]?.valueId]
              }
            })
          })

          const chooseSkuId = com.chooseSkuId
          // 处理回显
          const filterComMap: any = {}
          let filterCom: any = {}
          if (chooseSkuId) {
            const chooseSku = com.selectedSkuList.filter((item: any) => item.id === chooseSkuId)[0]
            const chooseSkuArgMap = chooseSku?.argMap || {}
            filterCom = com
            filterCom.selectSkuId = chooseSkuId
            filterCom.checked = true
            for (const valueKey in chooseSkuArgMap) {
              const value = chooseSkuArgMap[valueKey]
              if (value && value.valueId) {
                filterComMap[valueKey] = value.valueId
              }
            }

            // 处理报价详情时 报价属性回显相关回显
            if (!combinationInfoList?.length && packDtlList?.length) {
              packDtlList.forEach((item: any) => {
                if (item.sourceItemId === chooseSkuId) {
                  item?.materialDynaOptions?.forEach((arg: any) => {
                    item?.skuDynamicVoList?.forEach((skuDynamic: any) => {
                      if (skuDynamic.id === arg.id) {
                        arg.skuDynamicOptionVos = skuDynamic.skuDynamicOptionVos
                      }
                    })
                  })
                  filterCom.materialDynaOptions = item?.materialDynaOptions || []
                }
              })
            }
          } else if (combinationInfoList?.length) {
            // 选材时回显
            const filterList = combinationInfoList.filter((info: any) => info.id === com.id)
            if (filterList?.length) {
              filterCom = filterList[0]
              filterCom?.selectArgList?.forEach(
                (arg: any) => (filterComMap[arg?.argCode] = arg.argVal)
              )
            }
          }

          const useArgList = Object.keys(useArgMap)?.map((useKey: any) => {
            const spec = com.product.specificationArgList?.find(
              (item: any) => item.argCode === useKey
            )
            let newList = spec?.values?.filter((item: any) =>
              useArgMap[useKey]?.includes(item.valueId)
            )
            newList.forEach((item: any) => {
              item.isActive = filterComMap[useKey] === item.valueId
            })

            return {
              argCode: spec?.argCode,
              argName: spec?.argName,
              argId: spec?.id,
              argType: spec?.argType,
              list: newList,
            }
          })
          return {
            ...com,
            selectSkuId: filterCom?.selectSkuId || '',
            selectPrice: filterCom.selectPrice || '',
            checked: !filterCom ? true : filterCom.checked,
            materialDynaOptions: filterCom?.materialDynaOptions || [],
            useArgList,
          }
        })
        let mustChooseList = formatSpecList.filter((item: any) => item.required)
        let noMustChooseList = formatSpecList.filter((item: any) => !item.required)
        console.log('----mustChooseList----------', mustChooseList, noMustChooseList)
        getSkuDynamicVoList(mustChooseList, noMustChooseList)
      } else {
        message.error('无组合数据')
      }
    } catch (err) {
      console.log(err)
    }
  }
  const getSkuDynamicVoList = (mustChooseList, noMustChooseList) => {
    setSpinLoading(true)
    try {
      let list = [...mustChooseList, ...noMustChooseList]
      let queue = list.map(item => {
        if (item.selectSkuId) {
          return new Promise(resolve => {
            if (!item?.materialDynaOptions?.length) {
              selectMaterialDynaOptions({
                params: {
                  skuId: item.selectSkuId,
                },
              }).then(res => {
                resolve({
                  id: item.id,
                  skuDynamicVoList: res,
                })
              })
            } else {
              resolve({
                id: item.id,
                skuDynamicVoList: item.materialDynaOptions,
              })
            }
          })
        }
      })
      Promise.all(queue)
        .then((result: any) => {
          // setSpinLoading(false)
          list?.forEach((el: any) => {
            if (result && result?.length) {
              result?.forEach((rl: any) => {
                if (rl && el.id === rl.id) {
                  el.skuDynamicVoList = rl.skuDynamicVoList
                }
              })
            }
          })
          console.log(mustChooseList, noMustChooseList)
          setMustChooseList(mustChooseList)
          setNoMustChooseList(noMustChooseList)
        })
        .finally(() => {
          setBtnLoading(false)
          setSpinLoading(false)
        })
    } catch (err) {
      setBtnLoading(false)
      setSpinLoading(false)
    }
  }
  const showNationalTagRender = (item?: any) => {
    let newCombinationInfoList = [...mustChooseList, ...noMustChooseList]

    // 判断是否除了施工项都是国补 是则显示 国补标签
    let proList = newCombinationInfoList
      ?.filter(item => item?.product?.sourceType !== 'CONSTRUCTION')
      ?.filter(item => item.required || (!item.required && item.checked))
    let allNational = false
    if (proList?.length) {
      allNational = proList?.every((item: any) => {
        if (item.selectSkuId) {
          return item?.skuList?.find((sku: any) => sku.id === item.selectSkuId)?.showTags
        }
        return false
      })
    }
    if (allNational) {
      return (
        <div className={tagsMap.NATIONAL_UPPLEMENT}>
          <Tooltip placement="topLeft" title={'国补'}>
            国补
          </Tooltip>
        </div>
      )
    } else {
      return null
    }
  }

  const basicInfo = () => {
    console.log(kitSku, 'kitSku')
    console.log(productInfo, 'productInfo')
    return (
      <div className={styles.commodityBox}>
        <div className={styles.imgBox}>
          <Image.PreviewGroup items={productInfo?.imageUrls || undefined}>
            <Image src={productInfo?.mainPicUrl} />
          </Image.PreviewGroup>
        </div>
        <div className={styles.commodityInfo}>
          <div className={styles.commodityName}>
            {showNationalTagRender()}
            <Tooltip title={productInfo?.prodName} placement="topLeft">
              <p> {productInfo?.prodName}</p>
            </Tooltip>
          </div>
          <div className={styles.commodityPrice}>
            {
              /**
               * 先判断有没有选中sku，有就根据sku价格显示，没选中就看回显数据
               * 通项不显示价格
               */
              (kitSku as any)?.id && combinationPrice ? (
                <div className={styles.moneyBox}>
                  {combinationPrice && combinationPrice != '0' ? (
                    <>
                      <span className={styles.symbol}>￥</span>
                      <span className={styles.money}>{combinationPrice}</span>
                      <span>/{productInfo.unitInfo?.unitName}</span>
                    </>
                  ) : null}
                </div>
              ) : null
            }
          </div>
        </div>
      </div>
    )
  }

  const combinationContent = () => {
    return (
      <div className={styles.mainAndExtraContent}>
        {basicInfo()}
        <div className={styles.kitBox}>
          <KitDetailContent
            kitList={mustChooseList}
            noMustChooseList={noMustChooseList}
            setMustChooseList={setMustChooseList}
            setNoMustChooseList={setNoMustChooseList}
            formatCombinationData={formatCombinationData}
            combinationPriceType={combinationPriceType}
          />
        </div>
      </div>
    )
  }

  const dialogContent = () => {
    return (
      <Spin spinning={spinLoading}>
        <div
          className={styles.SpecificationDialogBox}
          style={{
            padding: '0 3px 0 3px',
          }}
        >
          <Form
            form={form}
            layout="horizontal"
            initialValues={{
              quoteBudgetVariableVos: [],
              spaceQuoteBudgetItemList: [],
              specsList: [],
            }}
            style={{
              width: '100%',
            }}
          >
            {combinationContent()}
          </Form>
        </div>
      </Spin>
    )
  }
  return (
    <ConfigProvider
      theme={{
        components: {
          Segmented: {
            itemSelectedBg: 'rgba(0, 100, 255, 1)',
            itemSelectedColor: '#fff',
            itemHoverBg: 'rgba(0, 100, 255, 1)',
            itemHoverColor: '#fff',
          },
        },
      }}
    >
      <div className={styles.specsDialog}>
        <SDrawerOrModal
          open={open}
          mode="modal"
          title="产品明细"
          children={dialogContent()}
          onCancel={() => closeDialog()}
          width={1000}
          antdProps={{
            maskClosable: false,
            destroyOnClose: true,
            ...{
              ...(readOnly
                ? { footer: null }
                : {
                    footer: (
                      <>
                        <Button
                          key="back"
                          onClick={() => {
                            // form.resetFields()
                            closeDialog()
                          }}
                        >
                          取消
                        </Button>
                        <Button
                          key="submit"
                          type="primary"
                          loading={btnLoading}
                          onClick={confirmDialog}
                        >
                          {okText ? '确定' : '加入选材车'}
                        </Button>
                      </>
                    ),
                  }),
            },
          }}
        />
      </div>
    </ConfigProvider>
  )
}

export default KitDetailDialogV3
